import { render, staticRenderFns } from "./vPullHook.vue?vue&type=template&id=523f82fe&"
import script from "./vPullHook.vue?vue&type=script&lang=js&"
export * from "./vPullHook.vue?vue&type=script&lang=js&"
import style0 from "./vPullHook.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports